module.exports = __webpack_public_path__ + "img/bg.31353f14.jpg";